module.exports = __webpack_public_path__ + "img/menu.47ea9067.svg";